
import Vue from "vue";
import {CIcon} from './services/icons-vue/src'
// plugins
import vuetify from "./plugins/vuetify"; // path to vuetify export

// Global error handler
Vue.config.errorHandler = (err, vm, info) => {
  console.error('[VUE ERROR HANDLER] Error:', err);
  console.error('[VUE ERROR HANDLER] Component:', vm?.$options?.name || 'Unknown');
  console.error('[VUE ERROR HANDLER] Info:', info);
  console.error('[VUE ERROR HANDLER] Stack:', err.stack);
};

// Window error handler for uncaught errors
window.addEventListener('error', (event) => {
  console.error('[WINDOW ERROR] Uncaught error:', event.error);
  console.error('[WINDOW ERROR] Message:', event.message);
  console.error('[WINDOW ERROR] Filename:', event.filename);
  console.error('[WINDOW ERROR] Line:', event.lineno, 'Column:', event.colno);
});

// Unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('[UNHANDLED REJECTION] Reason:', event.reason);
  console.error('[UNHANDLED REJECTION] Promise:', event.promise);
});


import {iconsSet as icons} from "./assets/icons/icons.js";
import {storePromise} from "./store/";
Vue.prototype.$fmtDate = function (date) {
  if (!date) return null;
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Africa/Cairo" }).format(new Date(date));
};
Vue.prototype.$fmtDateTime = function (date) {
  if (!date) return null;
  const d = new Date(date);
  const parts = new Intl.DateTimeFormat("en", { timeZone: "Africa/Cairo", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(d);
  const get = (t) => parts.find((p) => p.type === t)?.value || "";
  return `${get("year")}-${get("month")}-${get("day")} ${get("hour")}:${get("minute")}`;
};


// Import global CSS for frozen tables
import "./assets/css/frozen-tables.css";
// Import global CSS for sticky tables
import "./assets/css/sticky-tables.css";

import ECharts, {THEME_KEY} from "vue-echarts";

import "./plugins"

// Import AI tooltip directive
import "./directives/aiTooltip";
// Import auto scroll directive
import "./directives/autoScroll";

// Import scroll interceptor plugin
import axiosScrollInterceptor from "./plugins/axios-scroll-interceptor";


import App from "./App";
import router from "./router/index";

import filters from "./filters";
import middlewares from "./middlewares";
import mixin from "./mixins/index.js";



Vue.component("c-icon", CIcon);
Vue.component("e-charts", ECharts);

Vue.config.performance = true;

// Install scroll interceptor plugin
Vue.use(axiosScrollInterceptor);

Object.keys(filters).forEach(filter => {
  Vue.filter(filter, filters[filter]);
});


Vue.mixin(mixin);

storePromise.then(async (store) => {
  await import("./plugins/axios");
  // Initialize error interceptor
  await import("./services/errorInterceptor");
  // Initialize unified user activity service (replaces activityMonitor + aiContextService)
  const { default: userActivityService } = await import("./services/userActivityService");
  // Start monitoring after user is authenticated
  store.watch(
    (state) => state.authentication?.authUser,
    (authUser) => {
      if (authUser) {
        userActivityService.start();
      } else {
        userActivityService.stop();
        store.dispatch('app/stopLocationWatch');
      }
    },
    { immediate: true }
  );
  Object.keys(middlewares).forEach(name => {
    router.beforeEach(middlewares[name](store));
  });
  new Vue({
    el: "#app",
    store,
    router,
    provide: {
      [THEME_KEY]: 'white'
    },
    vuetify,
    async beforeCreate() {
      const websocketHost = import.meta.env.VITE_WEBSOCKET_HOST;
      const hostname = import.meta.env.MODE === 'production'
        ? window.location.hostname.split('.')[0]
        : import.meta.env.VITE_APP_NAME;
      await Promise.all([
        this.$store.dispatch("app/loadLocation"),
        this.$store.dispatch("initializeStore"),
        this.$store.dispatch(
          "app/loadOnlineChannel",
          `${websocketHost}/${hostname}/online`
        ),
        this.$store.dispatch("proactiveHelp/initialize"),
      ]);
    },
    icons,
    template: "<App/>",
    components: {
      App
    }
  });
})

